import { useEffect, useState, useMemo } from "react"
import { PublicKey } from "@solana/web3.js"
import { useWallet, useConnection } from "@solana/wallet-adapter-react"
import { Metadata } from "@metaplex-foundation/mpl-token-metadata"
import {
	checkCandyMachineStakable,
	getVaultAddress,
	getStakedDataByOwner,
	getRewardCalculator,
} from "../utils/staking"
///import { get } from "https"
export const useNfts = (refreshHandle) => {
	const { publicKey } = useWallet()
	const { connection } = useConnection()
	const [nfts, setNfts] = useState([])
	const [myStakedNfts, setStakedNfts] = useState([])
	const [stakableNfts, setStakableNfts] = useState([])
	const [stakableNftsA, setStakableNftsA] = useState([])
	const [stakableNftsB, setStakableNftsB] = useState([])

	const [programData, setProgramData] = useState(() => [])
	const [PROGRAMS, setPROGRAMS] = useState(() => [])

	//////////CHANGE TO FALSE FOR MAINNET/////
	const isDEVNET = false
	/////////////////CHANGE DEVNET ABOVE
	const getPROGRAM_DATA = (isDEVNET) => {
		const DEVNET = [
			{
				name: "A",
				ID: "6TTdTyqp3HKdAqmDCYdKudBjGxgGEVcVcei8yBo6q2Rp",
				vault: "BZFHH3EKJwjBYwFLHVxt3MCxtYjup7ZqHzmtd8qZBhj9",
				whitelist: "98JBKUQwRCzE9LpfxKUwgLyZtqLoh9GejyubekT1xh7x",
				REWARD_MINT: {
					pubkey: "7S9KMAufPHbh8xbHuseMKJXnUD3zjJMb9Hjszy3Jai4S",
					name: "MEAT",
					icon: "/img/Token.png",
				},
				bonus: 0,
				bonus_period: 1000000,
				minPeriod: 180,
				rewardPeriod: 15,
				rewardRate: 10,
				// in seconds
			},
			{
				name: "B",
				ID: "27HtaCqudnbTcq2ZatJy3HSMSAWokYfQwiPChcfudQP5",
				vault: "5dC6YQKEHHVswYvnKXPWfhnxFTUXMdpWJ9F3wCQwztqK",
				whitelist: "Bk8Dn76tFUzvBN9fg6GftzeYPHqfp8HFT9bupkNXYMEb",
				REWARD_MINT: {
					pubkey: "7S9KMAufPHbh8xbHuseMKJXnUD3zjJMb9Hjszy3Jai4S",
					name: "MEAT",
					icon: "/img/Token.png",
				},
				bonus: 0,
				bonus_period: 1000000,
				minPeriod: 70,
				rewardPeriod: 15,
				rewardRate: 100,
			},
		]
		const MAINNET = [
			{
				name: "REGULAR",
				ID: "5nGDNhPJNBm6yerPym3FWjPmaUWnMGxy6pDxCyZLx6yx",
				vault: "BrbcBLdLn63rws3mVACNnzypnFCYPnJTXd3ZHT8csHop",
				whitelist: "DC8jMvjjC9JeQ3DpWyGzSNG2Mev3UmPFnUZEMq4dzFq6",
				REWARD_MINT: {
					pubkey: "6cwW3gBpWnBU8UAsximLQVfbMySJqBG6LkFsozkr7BTg",
					name: "MEAT",
					icon: "/img/Token.png",
				},
				bonus: 0,
				bonus_period: 1000000,
				minPeriod: 180,
				rewardPeriod: 3600,
				rewardRate: 416666,
				// in seconds
			},
			{
				name: "BABY",
				ID: "Bh9CFDWyzAwseuF1QgmCai5fxfb38wQLxp3qCgBsmFy3",
				vault: "EjTzYxT4h5HmqECHRTxhcmtQBpPnor6DhVQY6PMuWBJt",
				whitelist: "3oAwrgSgczcLSU4wvWTCwa2tuFovvKgEmRYxxULYFdxC",
				REWARD_MINT: {
					pubkey: "6cwW3gBpWnBU8UAsximLQVfbMySJqBG6LkFsozkr7BTg",
					name: "MEAT",
					icon: "/img/Token.png",
				},
				bonus: 0,
				bonus_period: 1000000,
				minPeriod: 70,
				rewardPeriod: 3600,
				rewardRate: 416666,
			},
		]
		if (isDEVNET) {
			//devnet
			console.log("devnet ///////////")
			return DEVNET
		} else if (isDEVNET === false) {
			//mainnet
			console.log("mainnet ////////")
			return MAINNET
		} else {
			console.log("NO STAKING PROGRAMS AVAILABLE AT THIS TIME.")
			//add error checking
			return
		}
	}
	const getMyNftList = async () => {
		let stakedNfts = []

		for (let index = 0; index < PROGRAMS.length; index++) {
			const PROGRAM = PROGRAMS[index]
			const getstaked = async () =>
				await getStakedDataByOwner(
					connection,
					publicKey,
					PROGRAM.ID,
					PROGRAM.REWARDS
				).then((x) => x)

			await stakedNfts.push({
				name: PROGRAM.name,
				PID: PROGRAM.ID,
				REWARDS: PROGRAM.REWARDS,
				nfts: await getstaked((x) => x),
			})
		}

		let myNftList = []
		await Object.keys(stakedNfts).map(async (x) => {
			myNftList.push(...stakedNfts[x].nfts)
		})
		await console.log("MYLIST", myNftList)
		return await setStakedNfts(() => myNftList)
		//return myNftList
	}

	// const getStakableNftsA = async () => {
	// 	///console.log((await el()) ? true : false, "ELL")
	// 	const walletNfts = await Metadata.findDataByOwner(connection, publicKey)

	// 	let stakableB = []
	// 	for (let nft of walletNfts) {
	// 		if (
	// 			nft.data.creators &&
	// 			nft.data.creators[0]?.verified &&
	// 			(await checkCandyMachineStakable(
	// 				await PROGRAMS[0].ID.toString(),
	// 				connection,
	// 				nft.data.creators[0].address
	// 			))
	// 		) {
	// 			await stakableB.push({
	// 				mint: new PublicKey(nft.mint),
	// 				data: nft.data,
	// 				json: await fetch(nft.data.uri).then((e) => e.json()),
	// 				stakable: await PROGRAMS[0].ID,
	// 			})
	// 		}
	// 	}

	// 	await setStakableNftsA(() => stakableB)
	// }

	const getstakable = async () => {
		try {
			let stakable = []
			const walletNfts = await Metadata.findDataByOwner(connection, publicKey)
			for (let nft of walletNfts) {
				//console.log(nft.data.creators[0].address)
				if (
					(nft.data.creators &&
						nft.data.creators[0]?.verified &&
						nft.data.creators[0].address == PROGRAMS[0].whitelist) ||
					nft.data.creators[0].address == PROGRAMS[1].whitelist
				) {
					await stakable.push({
						mint: new PublicKey(nft.mint),
						data: nft.data,
						json: await fetch(nft.data.uri).then((e) => e.json()),
						stakable: nft.data.creators[0].address,
					})
				}
			}
			console.log(stakable, "STAKABLENFTS")
			return stakable
		} catch (error) {
			console.log(error)
		}
	}
	const getStakableNfts = async () => {
		const walletNfts = await Metadata.findDataByOwner(connection, publicKey)
		let all = []

		///	const canstakeB = await getstakable(PROGRAMS[1].ID).then((x) => x)

		//await all.push(canstake)

		// await Object.keys(stakedNfts).map(async (x) => {
		// 	myNftList.push(...stakedNfts[x].nfts)
		// })

		const canstakeB = async () =>
			await getstakable(PROGRAMS[1].ID).then((y) => y)

		await console.log("MYAAAAAaLIST", all)

		await setStakableNfts(async () => canstakeB())
		//	await console.log("canA", canstakeA(), "canB", canstakeB())

		//return all
		//await setStakedNfts(() => myNftList)
		//return myNftList
	}

	const getStakableNftsB = async () => {
		///console.log((await el()) ? true : false, "ELL")
		const walletNfts = await Metadata.findDataByOwner(connection, publicKey)

		let stakableB = []
		for (let nft of walletNfts) {
			if (
				(nft.data.creators &&
					nft.data.creators[0]?.verified &&
					(await checkCandyMachineStakable(
						ID[1].toString(),
						connection,
						nft.data.creators[0].address
					))) ||
				(nft.data.creators &&
					nft.data.creators[0]?.verified &&
					(await checkCandyMachineStakable(
						ID[0].toString(),
						connection,
						nft.data.creators[0].address
					)))
			) {
				await stakableB.push({
					mint: new PublicKey(nft.mint),
					data: nft.data,
					json: await fetch(nft.data.uri).then((e) => e.json()),
					stakable: "",
				})
			}
		}

		await setStakableNftsB(() => stakableB)
	}
	// const isStakable = useMemo(
	// 	async () => await getstakable(PROGRAMS[1].ID),
	// 	[PROGRAMS]
	// )

	useEffect(() => {
		;(async () => {
			// const clearCacheData = () => {
			// 	caches.keys().then((names) => {
			// 		names.forEach((name) => {
			// 			caches.delete(name)
			// 		})
			// 	})
			// 	//alert('Complete Cache Cleared')
			// }

			///await clearCacheData()

			const PROGRAM_DATA = await getPROGRAM_DATA(isDEVNET).map(async (x) => {
				const vault = await getVaultAddress(x.ID)
				const vaultData = await Metadata.findDataByOwner(connection, vault)
				const valutAccountInfo = await connection.getAccountInfo(vault)
				const rewardCalculator = await getRewardCalculator(
					connection,
					x.ID,
					valutAccountInfo,
					vault
				)
				const whitelist = x.whitelist
				const REWARDS = {
					REWARD_MINT: x.REWARD_MINT,
					vault: {
						address: await vault,
						holdings: await vaultData.length,
						vaultData: await vaultData,
					},
					...rewardCalculator,
					bonus: x.bonus,
					bonus_period: x.bonus_period,
					rewardRate: x.rewardRate,
				}

				const PROGRAM = {
					name: x.name,
					ID: x.ID,
					whitelist: whitelist,
					REWARDS,
				}
				console.log("PROGRAM " + x.name, PROGRAM)
				return PROGRAM
			})

			await Promise.all(PROGRAM_DATA).then(async (x) => {
				await setPROGRAMS(() => x)
			})
		})()
	}, [publicKey, refreshHandle, connection])

	useEffect(() => {
		if (!publicKey || !PROGRAMS[0]) return
		;(async () => {
			await getMyNftList()
			//	await getStakableNfts(PROGRAMS)

			//	console.log(await getstakable(PROGRAMS[0].ID).then((x) => x))
			// const go = [getstakable([PROGRAMS[0].ID, PROGRAMS[1].ID])]

			// await Promise.all(go).then(async (x) => {
			// 	await setStakableNfts(() => x)
			// 	await console.log(
			// 		"test",
			// 		x.map((x) => x)
			// 	)
			// 	//await console.log("PROGRAMS ", x, PROGRAMS)
			// })
			const c = await getstakable(PROGRAMS)
			await setStakableNfts(() => c)

			// await getstakable(await PROGRAMS[0].ID.toString()).then(async (x) => {
			// 	return x
			// 	//await console.log("PROGRAMS ", x, PROGRAMS)
			// })
			// await getStakableNftsA(PROGRAMS)
			// await getStakableNftsB(PROGRAMS)
			// const all = await stakableNftsB.concat(stakableNftsA)
			// await setStakableNfts(() => all)
		})()
	}, [PROGRAMS, refreshHandle])

	return { myStakedNfts, stakableNfts, PROGRAMS }
}
